export enum BaseRoutes {
  AUTOFIN_AUTO = '/app/publico/auto/financiamiento/',
}
